module.exports = __webpack_public_path__ + "Flag-376.0081b08abed6c828d88d095ab1a360ca.svg";